<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    
    <div class="row">
      <div class="col-md-12 mb-3">
        <h2 class="font-weight-800 text-transparencia">
          MÓDULOS
        </h2>
      </div>
    </div>
    
    <!-- Loading State -->
    <div v-if="cargando" class="row justify-content-center">
      <div class="col-md-12">
        <div class="text-center p-5">
          <div class="spinner-border text-transparencia" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-3 text-muted">Cargando módulos...</p>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="row justify-content-center">
      <div class="col-md-12">
        <div class="text-center p-5">
          <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
          <h5 class="text-muted">Error al cargar los módulos</h5>
          <p class="text-muted">{{ errorMessage }}</p>
          <button @click="fetchData" class="btn btn-outline-primary">
            <i class="fa fa-refresh mr-1"></i> Reintentar
          </button>
        </div>
      </div>
    </div>

    <!-- No Data State -->
    <div v-else-if="modulos.length === 0" class="row justify-content-center">
      <div class="col-md-12">
        <div class="text-center p-5">
          <i class="fa fa-graduation-cap fa-3x text-muted mb-3"></i>
          <h5 class="text-muted">No hay módulos disponibles</h5>
          <p class="text-muted">Los módulos aparecerán aquí una vez que estén configurados</p>
        </div>
      </div>
    </div>

    <!-- Modules Grid -->
    <div v-else class="row">
      <div v-for="(modulo, index) in modulos" :key="modulo.voluntariadoEodModuloId" class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mt-3">
        <div class="card card-frame card-owework border hover-shadow-9 transition-hover">
          <router-link class="fs-13 fw-600 text-center" :to="`/voluntariado/escuela-observadores-democraticos/modulos/${modulo.voluntariadoEodModuloId}`">
            <img 
              v-if="modulo.rutaImagen"
              class="img-fluid w-100 rounded cimage-slider" 
              :src="`${filesUrl}${modulo.rutaImagen}`" 
              :alt="modulo.titulo" 
            />
            <div v-else class="modulo-placeholder d-flex align-items-center justify-content-center" style="height: 250px; background: linear-gradient(135deg, #2484da 0%, #1e6bb8 100%);">
              <i class="fa fa-graduation-cap fa-3x text-white"></i>
            </div>
          </router-link>
          <div class="card-body p-2 pt-3" style="height:5.3rem !important;overflow-hidden">
            <router-link class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :to="`/voluntariado/escuela-observadores-democraticos/modulos/${modulo.voluntariadoEodModuloId}`">
              <h6 class="card-title fs-15 text-transparencia text-center">{{ modulo.titulo }}</h6>
            </router-link>
          </div>
          <div class="card-footer text-right pt-0">
            <router-link class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :to="`/voluntariado/escuela-observadores-democraticos/modulos/${modulo.voluntariadoEodModuloId}`">
              Ver detalle<i class="fa fa-search-plus ml-1"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";

export default {
  name: "view-modulos-eod",
  metaInfo: {
    title: "Módulos EOD",
  },
  components: { 
    layoutBreadcrumb
  },
  data: () => ({
    modulos: [],
    cargando: false,
    error: false,
    errorMessage: '',
    breadcrumbs: []
  }),
  methods: {
    async fetchData() {
      this.cargando = true;
      this.error = false;
      
      try {
        const response = await this.$http.get(this.apiRoute("Volunteering", "GetVoluntariadoEodModulos"));
        
        if (!response.body.error) {
          this.modulos = response.body.data || [];
          // Ordenar por prioridad
          this.modulos.sort((a, b) => a.prioridad - b.prioridad);
        } else {
          this.error = true;
          this.errorMessage = response.body.message || 'Error al cargar los módulos';
        }
      } catch (error) {
        this.error = true;
        this.errorMessage = 'Error de conexión al servidor';
      } finally {
        this.cargando = false;
      }
    },

    truncateHtml(html, maxLength) {
      if (!html) return '';
      
      // Crear elemento temporal para extraer texto
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const text = temp.textContent || temp.innerText || '';
      
      if (text.length <= maxLength) {
        return html;
      }
      
      // Truncar y agregar puntos suspensivos
      const truncated = text.substring(0, maxLength) + '...';
      return truncated;
    }
  },
  mounted: async function() {
    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Voluntariado", url: "/voluntariado", icon: "", active: false },
      { name: "Escuela de Observadores Democráticos", url: "/voluntariado/escuela-observadores-democraticos", icon: "", active: false },
      { name: "Módulos", url: "", icon: "", active: true },
    ];
    
    await this.fetchData();
  },
};
</script>

<style scoped>
.text-transparencia {
  color: #2484da !important;
}

.badge-primary {
  background-color: #2484da !important;
}
</style>
